import styles from "./Publication.module.scss";

interface Props {
  title: string;
  value: string | undefined;
}

const TitleValue: React.FC<Props> = ({ title, value }) => {
  return (
    <div className={styles.item}>
      {title != '' ?
      <div className={styles.title}>{title}:</div> : <></>}
      <div className={styles.value}>{value || ""}</div>
    </div>
  );
};

export default TitleValue;
